import { hasDefinedValue } from '@sgme/fp';
import type { PersistedTabContent, TradeAllocationPersistedTabContent } from 'apiConnector/tabs/tabs.model';
import { ofType } from 'redux-observable';
import { EMPTY } from 'rxjs';
import { catchError, filter, map } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { tradeAllocationFormRequested } from 'state/tradeAllocationForm/tradeAllocationForm.actions';

export function fillTradeAllocationTabContentInPostTradeScreenEpic(): EpicWithThunk {
  return (action$, _state$, { frontLogger }) => {
    return action$.pipe(
      ofType('WORKSPACE_TAB_CONTENT_FETCHED'),
      filter(({ workspace }) => workspace === 'postTrade'),
      filter(({ tabType }) => tabType === 'tradeAllocation'),
      filter(hasDefinedValue('tabContent')),
      map(({ tabId, tabContent }) => tradeAllocationFormRequestedFromTabContent(tabId, tabContent)),
      catchError(err => {
        frontLogger.error('Error in fillTradeAllocationTabContentInPostTradeScreenEpic {@FrontError}', err);
        return EMPTY;
      }),
    );
  };
}

const tradeAllocationFormRequestedFromTabContent = (tabId: string, tabContent: PersistedTabContent) => {
  const tradeAllocationTabContent = asTradeAllocationTabContent(tabContent);
  return tradeAllocationFormRequested(
    tabId,
    tradeAllocationTabContent.tradeId,
    tradeAllocationTabContent.product,
    tradeAllocationTabContent.wrapper,
    tradeAllocationTabContent.productId,
    tradeAllocationTabContent.rfqId,
    tradeAllocationTabContent.isin,
    tradeAllocationTabContent.fileCode,
  );
};

const asTradeAllocationTabContent = (tabContent: PersistedTabContent) =>
  tabContent as TradeAllocationPersistedTabContent;
